module.exports = __webpack_public_path__ + "assets/img/6f65a5e0d0c97e5aa25e98312a903d5e.svg";